<template>
  <div class="language">
    <button @click="$i18n.locale = 'no';selectedLanguage('Norwegian')">
      <img class="images"
           src="@/assets/flags/NO_small.png"
           alt="Norwegian flag"
      >
    </button>
    <div class="language">
      <button @click="$i18n.locale = 'sv';selectedLanguage('Swedish')">
        <img class="images"
             src="@/assets/flags/SE_small.png"
             alt="Swedish flag"
        >
      </button>
      <button @click="$i18n.locale = 'dk';selectedLanguage('Danish')">
        <img class="images"
             src="@/assets/flags/DK_small.png"
             alt="Danish flag"
        >
      </button>
      <button @click="$i18n.locale = 'en';selectedLanguage('English')">
        <img class="images"
             src="@/assets/flags/GB_small.png"
             alt="British flag"
        >
      </button>
    </div>
  </div>
</template>

<script setup>
import { useStore } from 'vuex'
const store = useStore()

function selectedLanguage (locale) {
  const isAuthenticated = localStorage.getItem('token')
  if (isAuthenticated) {
    store.dispatch('account/setLanguage', locale)
  }
  // localStorage.setItem('language', locale)
}

</script>

<style lang="scss" scoped>
.language {
    float: right;

    button {
        margin: 3px;
        font-size: 30px;
    }
    .images{
        width: 30px;
    }
}
</style>
